<template>
  <el-drawer
      title=""
      :visible.sync="drawerVisible"
      :direction="direction"
      :show-close="false">
    <el-form :model="form" ref="form" class="operate-after">
      <el-form-item class="operate-after-edit" prop="password">
        <el-input v-model="form.password"
                  type="text"
                  :placeholder="$t('userinfo.currentpassword')"
                  maxlength="20"
                  show-word-limit/>
        <!-- 取消-->
        <div class="edit" @click="cancel()">{{$t('friends.cancel')}}</div>
      </el-form-item>
      <el-form-item class="operate-after-edit" prop="newPassword">
        <el-input v-model="form.newPassword"
                  @input="changeNewPassword"
                  type="text"
                  :placeholder="$t('userinfo.newpassword')"
                  maxlength="20"
                  show-word-limit/>
      </el-form-item>
      <!-- 密码要求说明-->
      <div class="operate-after-desc">
        <!-- 您的密码必须具有-->
        <div class="operate-after-text">{{$t('userinfo.passwordmust')}}</div>
        <div class="operate-after-text ">
          <img :src="`${$g.imgPrefix}/img/userInfo/right.svg`">
          <!-- 任意字母，数字，特殊字符-->
          <span :class="newPassValid==1?'red-text-1':(newPassValid==2?'green-text-2':'')">{{$t('userinfo.anycharacter')}}</span>
        </div>
        <div class="operate-after-text">
          <img :src="`${$g.imgPrefix}/img/userInfo/right.svg`">
          <!-- 您输入的两个密码相同-->
          <span :class="confirmPassValid==1?'red-text-1':(confirmPassValid==2?'green-text-2':'')">{{$t('userinfo.twosamepasswords')}}</span>
        </div>
      </div>
      <!-- 确认密码-->
      <el-form-item class="operate-after-edit" prop="confirmPassword">
        <el-input v-model="form.confirmPassword"
                  @input="changeConfirmPassword"
                  type="text"
                  :placeholder="$t('userinfo.confirmpassword')"
                  maxlength="20"
                  show-word-limit/>
      </el-form-item>
      <!-- 更新密码-->
      <el-button
          class="green-btn-sm"
          :disabled="disabledUpdatePass"
          @click="saveData({
              password:form.password,
              newPassword:form.newPassword,
              confirmPassword:form.confirmPassword
              },'editPassword')">{{$t('userinfo.updatepassword')}}</el-button>
    </el-form>
  </el-drawer>
</template>

<script>
import {
  isPassword
} from "@/util/validate";
import {
  isEmpty, MessageError, MessageSuccess
} from "@/util/util"
import {updateUserById} from "@/request/requests";
export default {
  name: "resetPassword",
  data(){
    return{
      drawerVisible:false,
      direction:'btt',
      //新密码校验是否通过：未填写0  已填写未通过校验1  已填写通过校验2
      newPassValid: 0,
      //确认密码校验是否通过：未填写0  已填写未通过校验1  已填写通过校验2
      confirmPassValid: 0,
      form:{
        //当前密码
        password: '',
        //新密码
        newPassword: '',
        //确认密码
        confirmPassword: ''
      },

    }
  },
  computed:{
    disabledUpdatePass(){
      let flag = true;
      if((!this.isEmpty(this.form.newPassword) && this.newPassValid == 2)
          &&(!this.isEmpty(this.form.confirmPassword) && this.confirmPassValid == 2)
          && !this.isEmpty(this.form.password)){
        flag = false;
      }
      return flag;
    }
  },
  methods:{
    isEmpty,
    init(){
      this.drawerVisible = true;
    },
    async saveData(){
      let res = await updateUserById(this.form)
      if (res.status == "200") {
        //刷新info
        this.$emit('refreshInfo');
        this.cancel();
        MessageSuccess(res.msg)
      } else {
        MessageError(res.msg)
      }
    },
    changeNewPassword(newPass) {
      //新密码栏位是空
      if(this.isEmpty(newPass)){
        //校验通过：文言灰色
        this.newPassValid = 0;
        return
      }
      //新密码不为空 需要校验密码规则
      if(!isPassword(newPass)){
        //校验不通过：文言红色
        this.newPassValid = 1;
      }else{
        //校验通过：文言绿色
        this.newPassValid = 2;
      }

      //确认密码
      this.changeConfirmPassword(this.form.confirmPassword)
    },
    changeConfirmPassword(corfirmPass) {
      //新密码栏位是空
      if (this.isEmpty(corfirmPass)) {
        //校验通过：文言灰色
        this.confirmPassValid = 0;
        return
      }
      //确认密码校验规则判断
      if (corfirmPass != this.form.newPassword) {
        //校验不通过：文言红色
        this.confirmPassValid = 1;
      } else {
        //校验通过：文言绿色
        this.confirmPassValid = 2;
      }
    },
    cancel(){
      this.drawerVisible = false;
      Object.assign(this.$data.form, this.$options.data().form);
      this.newPassValid = 0;
      this.confirmPassValid = 0;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/userInfo.scss";
::v-deep .el-drawer.btt{
  height:50%!important;
}
</style>